/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Cliente from "../Formularios/Formulario_Cliente";
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {adicionarDepartamento} from "../FuncionesExternas/adicionarDepartamento";
import {registrarDoc} from "../../Modulo_Algolia/Funciones/registrarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {borrarRegistro} from "../../Modulo_Algolia/Funciones/borrarRegistro";

const Dialogo_Cliente = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrar, funcionDos: realizado})
    const {Cargador, abrirCargador, setDetener} = useLoaders({logo: logo})


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        abrirCargador('Guardando Datos')
        entidad.fecha = new Date().getTime()

        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        nuevoAviso({aviso: 'Imagen subida'})
        let id = await guardarDoc('clientes', entidad)
        nuevoAviso({aviso: 'Datos Subidos'})

        let registro = await registrarDoc({nombreIndex: 'clientes', obj: entidad})

        let adicionDepartamento = await adicionarDepartamento(entidad.departamento)

        if (adicionDepartamento.res) {
            setTimeout(() => {
                setDetener(true)
                terminar({aviso: 'Cliente creado con exito'})
            }, 500)
        } else {
            alert(adicionDepartamento.data)
        }

    }

    const borrar = async () => {
        await borrarDoc('clientes', datos.id)
        await borrarRegistro({nombreIndex:'clientes', id: datos.id})
        terminar({aviso: 'Registro borrado'})
    }
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Cliente props={props}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }


        </Grid2>
    )

}
export default Dialogo_Cliente